import {gsap} from "gsap";

$(document).on('click', '.sec-2__pet--more', (e) => {
  e.preventDefault();
  $('.sec-2__pet--layer').toggle();
});

$(document).on('click', '.sec-2__pet--layer .btn-close', (e) => {
  e.preventDefault();
  $('.sec-2__pet--layer').hide();
});

$(document).on('click', '.sec-2__pet--btn--coupon', (e) => {
  e.preventDefault();
  promokit.coupon();
});

$(document).on('click', '.sec-2__sns__btn', (e) => {
  e.preventDefault();
  const url = 'https://aion.plaync.com/update/history/2020/201028_classic#section-2';
  const classStr = $(e.currentTarget).attr('class');

  promokit.share({
    target: classStr.split('sec-2__sns__btn ')[1],
    url: url
  });
});

const animation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('#section-2 .sec-common__title', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-2 .sec-common__subtitle', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-2 .sec-common__period', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-2 .sec-2__apply', {opacity: 0, y: 20,  duration: .6}, 'start+=0.4')
    .from('#section-2 .sec-2__pet', {opacity: 0, y: 20, duration: .6}, 'start+=0.4')
    .from('#section-2 .sec-2__sns', {opacity: 0, y: 20, duration: .6}, 'start+=0.4');

export default {
  id: '#section-2',
  name: '사전 예약 신청',
  enterEnd() {
    animation.play();
  },
  leaveEnd() {
    animation.seek(0).pause();
  }
};



// WEBPACK FOOTER //
// ./src/js/section-2.js